import { render } from "./Register.vue?vue&type=template&id=d2299446&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=d2299446&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Register\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2299446"]])

export default __exports__